import {getConfiguration} from "./environment-variable-helper";
import {Env} from "@stencil/core";

export function isConfigurationDefined(configName: string): boolean {
  return (typeof configuration != "undefined" && typeof configuration.data != "undefined" && typeof configuration.data[configName] != "undefined")
}

export function isEnvironmentVariableDefined(configName: string): boolean {
  const env = getConfiguration(Env.environment);
  return !(typeof env[configName] == "undefined" || env[configName] == null);
}

export function getConfigOrEnvVariable(configName: string) {
  const env = getConfiguration(Env.environment);
  let returnValue;

  if (isConfigurationDefined(configName)) {
    returnValue = configuration.data[configName];
  } else if (isEnvironmentVariableDefined(configName)) {
    returnValue = env[configName];
  } else {
    returnValue = undefined;
    console.error('Configuration or Environment Variable is missing for ', configName);
  }

  return returnValue;
}
